<script setup lang="ts">
/**
 * Toast Container
 * Mount once in App.vue — renders the reactive toast queue.
 */
import { useToast } from '@/composables/useToast'
import ToastItem from './ToastItem.vue'

const { queue, remove } = useToast()
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed bottom-6 right-6 z-[var(--z-toast)] flex flex-col gap-2.5 pointer-events-none max-sm:left-4 max-sm:right-4 max-sm:bottom-4"
      aria-live="polite"
    >
      <TransitionGroup
        enter-active-class="animate-toast-slide-in"
        leave-active-class="animate-toast-slide-out"
      >
        <ToastItem
          v-for="item in queue"
          :key="item.id"
          :id="item.id"
          :message="item.message"
          :type="item.type"
          :duration="item.duration"
          @close="remove"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>
